"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualFabricMapMarkers = exports.ClusteredFabricMapMarkers = exports.FabricMapMarkers = void 0;
const React = __importStar(require("react"));
const _1 = require(".");
const __1 = require("../..");
const util_1 = require("../../util");
const FabricMapClusters_1 = require("../FabricMapClusters");
const isObject_1 = __importDefault(require("lodash/isObject"));
require("./FabricMapMarker.scss");
const FabricMapMarkers_helpers_1 = require("./FabricMapMarkers.helpers");
/**
 * Component to render MapBox markers in Granular's style
 * Must be a child of FabricMapHost
 *
 * You may _alternately_ pass react-mapbox-gl Marker components directly as children.
 *
 * @note If you see a type error on this component, it's likely because you gave it both children and a markers prop.
 */
const FabricMapMarkers = (props) => {
    const { cluster } = props, restProps = __rest(props, ["cluster"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(util_1.Conditional, { match: !!cluster },
            React.createElement(exports.ClusteredFabricMapMarkers, Object.assign({}, restProps, { 
                // Casting this to an object here lets us do some object destructuring in the component
                cluster: (0, isObject_1.default)(cluster) ? cluster : {} }))),
        React.createElement(util_1.Conditional, { match: !cluster },
            React.createElement(exports.IndividualFabricMapMarkers, Object.assign({}, restProps)))));
};
exports.FabricMapMarkers = FabricMapMarkers;
const ClusteredFabricMapMarkers = (props) => {
    const { children, markers, cluster } = props, passThroughProps = __rest(props, ["children", "markers", "cluster"]);
    const [isClustering, setIsClustering] = React.useState(false);
    const map = (0, __1.useMap)();
    const layer = React.useMemo(() => markers
        ? (0, FabricMapMarkers_helpers_1.markerPropsToFeatureCollection)(markers)
        : children
            ? (0, FabricMapMarkers_helpers_1.childrenToFeatureCollection)(children)
            : null, [children, markers]);
    const onClusterSwitch = React.useCallback((clustering, map) => {
        setIsClustering(!!clustering);
        if ((0, isObject_1.default)(cluster) && (cluster === null || cluster === void 0 ? void 0 : cluster.onClusterSwitch)) {
            cluster.onClusterSwitch(clustering, map);
        }
    }, [cluster]);
    const combinedClusterOptions = React.useMemo(() => (Object.assign(Object.assign({ clusterMaxZoom: 18, clusterRadius: 100, idPrefix: "fabric-map-clusters" }, ((0, isObject_1.default)(cluster) ? cluster : {})), { onClusterSwitch })), [onClusterSwitch, cluster]);
    if (!layer || !map) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FabricMapClusters_1.FabricMapClusters, Object.assign({ layer: layer, layersToHideWhenClustering: [], map: map }, combinedClusterOptions)),
        markers ? (React.createElement(exports.IndividualFabricMapMarkers, Object.assign({}, Object.assign(Object.assign({}, passThroughProps), { markers }), { className: isClustering ? "d-none" : "" }))) : children ? (React.createElement(exports.IndividualFabricMapMarkers, Object.assign({}, Object.assign(Object.assign({}, passThroughProps), { children }), { className: isClustering ? "d-none" : "" }))) : (React.createElement(React.Fragment, null))));
};
exports.ClusteredFabricMapMarkers = ClusteredFabricMapMarkers;
const IndividualFabricMapMarkers = (props) => {
    const { children, markers, markerClassName, className } = props;
    return (React.createElement("span", { className: className, "data-qa": "individual-fabric-markers" },
        React.createElement(util_1.Conditional, { match: !!markers }, markers &&
            markers.map((props, index) => (React.createElement(_1.FabricMapMarker, Object.assign({ key: index, className: markerClassName }, props))))),
        React.createElement(util_1.Conditional, { match: !!children }, children)));
};
exports.IndividualFabricMapMarkers = IndividualFabricMapMarkers;
exports.default = exports.FabricMapMarkers;
